var render = function render(){var _vm=this,_c=_vm._self._c;return _c('i',{staticClass:"material-icons is-usable"},[_vm._v(" "+_vm._s(_vm.iconName)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }